import React from 'react';

const Svg = (): React.ReactElement => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14.0609 9.01017C14.6132 9.01017 15.0609 8.56246 15.0609 8.01018L15.0609 7.98987C15.0609 7.43758 14.6132 6.98987 14.0609 6.98987L11.0101 6.98987C9.90558 6.98987 9.01015 6.09444 9.01015 4.98987L9.01015 1.93911C9.01015 1.38682 8.56243 0.939109 8.01015 0.939109L7.98985 0.939109C7.43756 0.939109 6.98985 1.38682 6.98985 1.93911L6.98985 4.98987C6.98985 6.09444 6.09441 6.98987 4.98985 6.98987L1.93909 6.98987C1.3868 6.98987 0.939088 7.43758 0.939088 7.98987L0.939088 8.01017C0.939088 8.56246 1.3868 9.01017 1.93909 9.01017L4.98985 9.01017C6.09442 9.01017 6.98985 9.9056 6.98985 11.0102L6.98985 14.0609C6.98985 14.6132 7.43756 15.0609 7.98985 15.0609H8.01015C8.56244 15.0609 9.01015 14.6132 9.01015 14.0609L9.01015 11.0102C9.01015 9.9056 9.90558 9.01017 11.0102 9.01017L14.0609 9.01017Z"
        fill="white"
      />
    </svg>
  );
};

export default Svg;
